import InstructionScene from './scenes/InstructionScene';
import PauseScene from './scenes/PauseScene';
import PlayScene from './scenes/PlayScene';
import TitleScene from './scenes/TitleScene';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [TitleScene, InstructionScene, PlayScene, PauseScene],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: TitleScene.KEY,

  // startScene: InstructionScene.KEY,
  // startScene: PlayScene.KEY,

  config: {
    gameProgress: null,
    hasMotionControls: false,
    musicMuted: false,
    soundMuted: false,
    scaling: 1.0,
    startPaused: false,
    gameSize: { width: 768, height: 1024 },

    advancedTiming: true,
    showDebugAll: false,
    justDoQuestions: false,

    playerGravity: 1400,
    jumpHeight: 1080,
    platformSpacing: 220,
    platformXMin: 200,
    platformXMax: 300,
    questionSpacing: 15,
    showQuestion: true,

    controls: 2,
    INPUT_KEYBOARD: 2,
    INPUT_BUTTONS: 4,
    INPUT_MOTION: 8,

    allowMouse: true,
    enableMouse: true,
    mainSheet: 'assetsheet',
    abcg: 1100
  },

  gameProps: {
    isPaused: false,
    isMuted: false,

    pieces1: [
      {
        textureId: 'piece+1',
        spriteId: 'piece+1',
        x: 10,
        y: 0,
        rotation: 0,
        layerDepth: 10,
        vx: -2,
        vy: -1
      },
      {
        textureId: 'piece+2',
        spriteId: 'piece+2',
        x: 0,
        y: 0,
        rotation: 0,
        layerDepth: 9,
        vx: -2,
        vy: 0
      },
      {
        textureId: 'piece+3',
        spriteId: 'piece+3',
        x: 0,
        y: 19,
        rotation: 0,
        layerDepth: 8,
        vx: -2,
        vy: 1
      },
      {
        textureId: 'piece+4',
        spriteId: 'piece+4',
        x: 30,
        y: 0,
        rotation: 0,
        layerDepth: 7,
        vx: -1,
        vy: 0
      },
      {
        textureId: 'piece+5',
        spriteId: 'piece+5',
        x: 23,
        y: 13,
        rotation: 0,
        layerDepth: 6,
        vx: -1,
        vy: 0
      },
      {
        textureId: 'piece+6',
        spriteId: 'piece+6',
        x: 63,
        y: 0,
        rotation: 0,
        layerDepth: 5,
        vx: 0,
        vy: 0
      },
      {
        textureId: 'piece+7',
        spriteId: 'piece+7',
        x: 65,
        y: 17,
        rotation: 0,
        layerDepth: 4,
        vx: 0,
        vy: 1
      },
      {
        textureId: 'piece+8',
        spriteId: 'piece+8',
        x: 116,
        y: 0,
        rotation: 0,
        layerDepth: 3,
        vx: 1,
        vy: -1
      },
      {
        textureId: 'piece+9',
        spriteId: 'piece+9',
        x: 103,
        y: 8,
        rotation: 0,
        layerDepth: 2,
        vx: 1,
        vy: 0
      },
      {
        textureId: 'piece+10',
        spriteId: 'piece+10',
        x: 148,
        y: 0,
        rotation: 0,
        layerDepth: 1,
        vx: 2,
        vy: 0
      },
      {
        textureId: 'piece+11',
        spriteId: 'piece+11',
        x: 136,
        y: 11,
        rotation: 0,
        layerDepth: 0,
        vx: 2,
        vy: 1
      }
    ]
  },

  itemsToCollect: [
    { id: 1, type: 'glasses', texture: 'black_glasses', offset: { x: 0, y: -26 } },
    { id: 2, type: 'glasses', texture: 'purple_glasses', offset: { x: 0, y: -26 } },
    { id: 12, type: 'glasses', texture: 'red_glasses', offset: { x: 0, y: -26 } },
    { id: 3, type: 'brush', texture: 'blue_brush', value: 'blue', color: 0xaddddc },
    { id: 4, type: 'brush', texture: 'green_brush', value: 'green', color: 0xc8f264 },
    { id: 5, type: 'brush', texture: 'orange_brush', value: 'orange', color: 0xffa05f },
    { id: 6, type: 'brush', texture: 'purple_brush', value: 'purple', color: 0xd589b3 },
    { id: 7, type: 'brush', texture: 'red_brush', value: 'red', color: 0xf16d4b },
    { id: 8, type: 'brush', texture: 'yellow_brush', value: 'yellow', color: 0xf4c662 },
    { id: 9, type: 'hat', texture: 'jester_hat', offset: { x: 2, y: -56 } },
    { id: 10, type: 'hat', texture: 'party_hat', offset: { x: -5, y: -63 } },
    { id: 11, type: 'hat', texture: 'pinwheel_hat', offset: { x: -3, y: -56 } }
  ],

  hats: [
    { id: 9, type: 'hat', texture: 'jester_hat', offset: { x: 2, y: -56 } },
    { id: 10, type: 'hat', texture: 'party_hat', offset: { x: -5, y: -63 } },
    { id: 11, type: 'hat', texture: 'pinwheel_hat', offset: { x: -3, y: -56 } }
  ],

  glasses: [
    { id: 1, type: 'glasses', texture: 'black_glasses', offset: { x: 0, y: -26 } },
    { id: 2, type: 'glasses', texture: 'purple_glasses', offset: { x: 0, y: -26 } },
    { id: 12, type: 'glasses', texture: 'red_glasses', offset: { x: 0, y: -26 } }
  ],

  brushes: [
    { id: 3, type: 'brush', texture: 'blue_brush', value: 'blue', color: 0xaddddc },
    { id: 4, type: 'brush', texture: 'green_brush', value: 'green', color: 0xc8f264 },
    { id: 5, type: 'brush', texture: 'orange_brush', value: 'orange', color: 0xffa05f },
    { id: 6, type: 'brush', texture: 'purple_brush', value: 'purple', color: 0xd589b3 },
    { id: 7, type: 'brush', texture: 'red_brush', value: 'red', color: 0xf16d4b },
    { id: 8, type: 'brush', texture: 'yellow_brush', value: 'yellow', color: 0xf4c662 }
  ]
};
